// Device-local editable source. Never sent as public avatar or shared between owners.
const storage=require('../offline/storage');
const ownerKey=name=>String(name||'').toLowerCase();
const key=name=>'avatar-source-r33:'+ownerKey(name);
function currentOwner(name){return ownerKey(sessionStorage.getItem('username'))===ownerKey(name)&&Boolean(sessionStorage.getItem('reconnectToken'));}
async function loadAvatarDraft(name,remote){
 if(!currentOwner(name))return null;
 const saved=await storage.read(key(name)).catch(()=>null);
 return currentOwner(name)&&saved?.owner===ownerKey(name)&&saved.remote===remote&&saved.source instanceof Blob?saved:null;
}
async function saveAvatarDraft(name,remote,source,crop){
 if(!currentOwner(name))return false;
 await storage.write(key(name),{owner:ownerKey(name),remote,source,crop:{x:crop.x,y:crop.y,zoom:crop.zoom}});return true;
}
function forgetAvatarDraft(name){return Promise.resolve().then(()=>storage.write(key(name),null)).catch(()=>{});}
// Keep the complete image, normalized and bounded for persistent device storage.
async function editableAvatarSource(image){
 const w=image.naturalWidth||image.width,h=image.naturalHeight||image.height,scale=Math.min(1,2048/Math.max(w,h));
 const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(w*scale));canvas.height=Math.max(1,Math.round(h*scale));
 const ctx=canvas.getContext('2d');if(!ctx)throw Error('Fotoğraf kaynağı hazırlanamadı.');
 ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.drawImage(image,0,0,canvas.width,canvas.height);
 return new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(Error('Fotoğraf kaynağı hazırlanamadı.')),'image/jpeg',.92));
}
module.exports={loadAvatarDraft,saveAvatarDraft,forgetAvatarDraft,editableAvatarSource};
